import { TenantTheme } from '../tenants/';

const skeletonTheme = (theme: TenantTheme) => ({
  primaryColor: theme.palette.neutral.shade3,
  secondaryColor: theme.palette.neutral.shade1,
});

export default skeletonTheme;
